// CategoryList.js
import React, { useState } from "react";
import { useGetHomepageCategoriesQuery } from "../../slices/homepageSlice";

const CategoryList = () => {
  const { data: categories } = useGetHomepageCategoriesQuery();
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategoryClick = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  return (
    // <div className="category-list h-full overflow-y-auto bg-white shadow-md p-4 rounded-md w-56">
    //   {categories?.map((category) => (
    //     <div
    //       key={category._id}
    //       className={`category-item flex items-center px-2 py-1 rounded-md cursor-pointer ${
    //         selectedCategory === category._id ? "bg-white" : "hover:bg-agBg"
    //       }`}
    //       onClick={() => handleCategoryClick(category._id)}
    //     >
    //       <img
    //         src={category.image}
    //         alt={category.title}
    //         className="w-8 h-8 mr-4 rounded-md"
    //       />
    //       <p className="text-xs text-agBlack">{category.title}</p>
    //     </div>
    //   ))}
    //   <a href="#" className="text-agBlue text-xs text-right mt-4 block">
    //     view more
    //   </a>
    // </div>
    <></>
  );
};

export default CategoryList;
